import {ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

import {PoleList} from '../../../services/pole-list-service/pole-list';
import {BehaviorSubject, Observable} from 'rxjs';
import {PoleItem} from '../../../services/pole-list-service/pole-item';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ConfigService} from '../../../services/config-service/config.service';
import {InspectionService} from '../../../inspect/services/inspection-service/inspection.service';


@Component({
    selector: 'app-pole-details',
    templateUrl: './pole-details.component.html',
    styleUrls: ['./pole-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PoleDetailsComponent implements OnInit, OnChanges, OnDestroy {
    @Input() poleList: PoleList;

    inspectionBatchPoleImages;

    latLonSource: BehaviorSubject<string>;
    latLon$: Observable<string>;

    googleLinkSource: BehaviorSubject<string>;
    googleLink$: Observable<string>;

    currentPoleSubscription = null;

    constructor(public inspectionService: InspectionService,
                public config: ConfigService) {
        this.latLonSource = new BehaviorSubject<string>('');
        this.latLon$ = this.latLonSource.asObservable();

        this.googleLinkSource = new BehaviorSubject<string>('');
        this.googleLink$ = this.googleLinkSource.asObservable();
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        // // Update the note status when the poleImage is updated
        if (changes.poleList) {
            if (this.poleList) {
                // Unsubscribe if we are already subscribed
                if (this.currentPoleSubscription) {
                    this.currentPoleSubscription.unsubscribe();
                    this.currentPoleSubscription = null;
                }

                // Subscribe to the new currentPoleItem Observable
                this.currentPoleSubscription = this.poleList.currentPoleItem$.subscribe(poleItem => {
                    this.updateGoogleLink(poleItem);
                });
            }
        }
    }

    ngOnDestroy() {
        if (this.currentPoleSubscription) {
            this.currentPoleSubscription.unsubscribe();
            this.currentPoleSubscription = null;
        }
    }

    updateGoogleLink(poleItem: PoleItem) {
        if (poleItem &&
            poleItem.pole &&
            poleItem.pole.location) {

            const pole = poleItem.pole;

            // console.log('poleImage: ', pole);
            const lat = pole.location[1];
            const lon = pole.location[0];

            const url = `https://maps.google.com/maps?z=20&t=h&q=${lat},${lon}`;
            // const url = `https://www.google.com/maps/@?api=1&map_action=map&center=${lat},${lon}&basemap=satellite&zoom=19`;

            this.latLon = lat.toFixed(6) + ', ' + lon.toFixed(6);
            this.googleLink = url;
        } else {
            this.latLon = null;
            this.googleLink = null;
        }
    }

    get latLon(): string {
        return this.latLonSource.getValue();
    }

    set latLon(value: string) {
        this.latLonSource.next(value);
    }

    get googleLink(): string {
        return this.googleLinkSource.getValue();
    }

    set googleLink(value: string) {
        this.googleLinkSource.next(value);
    }

    // async inspectionBatchChanged(event) {
    //   const inspectionBatchId = event.value;
    //
    //   await this.inspectorService.setCurrentInspectionBatch(inspectionBatchId);
    // }
}
